import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListChangePointCustomer = createAsyncThunk(
    "changePoint/getListChangePointCustomer",
    async ({ currentPage, pageSize}, { rejectWithValue }) => {
        try {
            let apiUrl = `/api/v1/serviceconnect/change-points?has_paginate&size=${pageSize}&page=${currentPage}`;
            const response = await http.get(apiUrl);
            return response.data;
        } catch (error) {
            return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);

export const checkCustomerByPhone = createAsyncThunk(
    "changePoint/checkCustomerByPhone",
    async (data, { rejectWithValue }) => {
      try {
        const response = await http.post(`/api/v1/serviceconnect/change-points/check-by-phone`, data);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

export const changePointCustomer = createAsyncThunk(
  "changePoint/changePointCustomer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/change-points`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);